
<template>
  <v-dialog v-model="dialog" persistent max-width="60%">
    <v-stepper v-model="stepper" vertical>
      <validation-observer ref="form">
        <v-toolbar elevation="0">
          {{ $t("* Required fields") }}
          <v-spacer></v-spacer>
          <v-btn
            class="mx-2 mt-2 right"
            fab
            dark
            small
            color="red"
            @click.stop="
              $emit('close');
              stepper = 1;
              switchBillingAddress = false;
            "
          >
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-stepper-step
          :rules="[() => booleanStepper1]"
          class="pt-0"
          :complete="stepper > 1"
          step="1"
        >
          <span class="headline">{{ formTitle }}</span>
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-card class="mb-12 mx-2 px-2">
            <validation-provider
              v-slot="{ errors }"
              name="name"
              rules="required|max:255"
            >
              <v-text-field
                data-cy="text-field-name-entity"
                name="name"
                v-model="editedItem.name"
                :label="`${$t('Name')} *`"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="street1"
              rules="required|max:255"
            >
              <v-text-field
                data-cy="text-field-street1-entity"
                name="street1"
                v-model="editedItem.street1"
                :label="`${$t('Address 1')} *`"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="street2"
              rules="max:255"
            >
              <v-text-field
                name="street2"
                v-model="editedItem.street2"
                :label="$t('Address 2')"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="street3"
              rules="max:255"
            >
              <v-text-field
                name="street3"
                v-model="editedItem.street3"
                :label="$t('Address 3')"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="postal_code"
              rules="required|max:255"
            >
              <v-text-field
                data-cy="text-field-postal-code-entity"
                name="postal_code"
                v-model="editedItem.postal_code"
                :label="`${$t('Postal code')} *`"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="city"
              rules="required|max:255"
            >
              <v-text-field
                data-cy="text-field-city-entity"
                name="city"
                v-model="editedItem.city"
                :label="`${$t('City')} *`"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="country"
              rules="required|max:255"
            >
              <v-autocomplete
                data-cy="autocomplete-country-entity"
                name="country"
                v-model="editedItem.country"
                :items="countriesList"
                item-text="name"
                item-value="code"
                :label="`${$t('Country')} *`"
                :error-messages="errors"
              ></v-autocomplete>
            </validation-provider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click.stop="
                  $emit('close');
                  stepper = 1;
                  switchBillingAddress = false;
                "
                >{{ $t("Cancel") }}</v-btn
              >
              <v-btn
                data-cy="button-next-entity"
                color="primary"
                @click="stepper = 2"
                >{{ $t("Next") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-step
          :rules="[() => booleanStepper2]"
          :complete="stepper > 2"
          step="2"
          >{{ $t("Billing address") }}</v-stepper-step
        >
        <v-stepper-content step="2">
          <v-card class="mb-12 mx-2 px-2">
            <v-switch
              data-cy="switch-billing-address-entity"
              v-if="this.editedId === -1"
              v-model="switchBillingAddress"
              :label="$t('Identical billing address')"
              @change="autoCompleteBillingAddress()"
            ></v-switch>
            <validation-provider
              v-slot="{ errors }"
              name="billing_street1"
              rules="required|max:255"
            >
              <v-text-field
                name="billing_street1"
                v-model="editedItem.billing_street1"
                :label="`${$t('Address 1')} *`"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="billing_street2"
              rules="max:255"
            >
              <v-text-field
                name="billing_street2"
                v-model="editedItem.billing_street2"
                :label="$t('Address 2')"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="billing_street3"
              rules="max:255"
            >
              <v-text-field
                name="billing_street3"
                v-model="editedItem.billing_street3"
                :label="$t('Address 3')"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="billing_postal_code"
              rules="required|max:255"
            >
              <v-text-field
                name="billing_postal_code"
                v-model="editedItem.billing_postal_code"
                :label="`${$t('Postal code')} *`"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="billing_city"
              rules="required|max:255"
            >
              <v-text-field
                name="billing_city"
                v-model="editedItem.billing_city"
                :label="`${$t('City')} *`"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="billing_country"
              rules="required|max:255"
            >
              <v-autocomplete
                name="billing_country"
                v-model="editedItem.billing_country"
                :items="countriesList"
                item-text="name"
                item-value="code"
                :label="`${$t('Country')} *`"
                :error-messages="errors"
              ></v-autocomplete>
            </validation-provider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click.stop="stepper = 1">{{
                $t("Previous")
              }}</v-btn>
              <v-btn
                data-cy="button-next-second-step-entity"
                color="primary"
                @click="stepper = 3"
                >{{ $t("Next") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-step
          :rules="[() => booleanStepper3]"
          :complete="stepper > 3"
          step="3"
          >{{ $t("Company information") }}</v-stepper-step
        >

        <v-stepper-content step="3">
          <v-card class="mb-12 mx-2 px-2">
            <validation-provider
              v-if="isFrenchTerritory"
              v-slot="{ errors }"
              name="siret"
              rules="required|numeric|length:14"
            >
              <v-text-field
                data-cy="text-fiel-siret-entity"
                name="siret"
                v-model="editedItem.siret"
                label="SIRET *"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-if="countriesEuropean"
              v-slot="{ errors }"
              name="vat"
              rules="required"
            >
              <v-text-field
                data-cy="text-field-vat-entity"
                name="vat"
                v-model="editedItem.vat"
                :label="`${$t('V.A.T.')} *`"
                :error-messages="errors"
                hint="FR12345678907"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-if="!countriesEuropean"
              v-slot="{ errors }"
              name="fiscal_number_reference"
              rules="required|max:50"
            >
              <v-text-field
                data-cy="text-field-fiscal-number-entity"
                name="fiscal_number_reference"
                v-model="editedItem.fiscal_number_reference"
                :label="`${$t('Fiscal number reference')} *`"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click.stop="stepper = 2">{{
                $t("Previous")
              }}</v-btn>
              <v-btn
                data-cy="button-save-entity"
                color="primary"
                :loading="loading"
                text
                @click.stop="save"
                >{{ $t("Save") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </validation-observer>
    </v-stepper>
  </v-dialog>
</template>

<script>
import snackbar from "@/mixins/snackbar";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import countries from "i18n-iso-countries";

export default {
  name: "AddEditEntityDialog",
  props: ["value"],
  components: { ValidationObserver, ValidationProvider },
  mixins: [snackbar],
  data() {
    return {
      loading: false,
      countries: countries.getNames(this.$i18n.locale),
      stepper: 1,
      switchBillingAddress: false,
      dataMounted: false,
    };
  },
  watch: {
    dialog(value) {
      if (value) {
        setTimeout(() => {
          this.dataMounted = true;
        }, 1000);
      }
      if (value && this.$refs.form) {
        this.$refs.form.reset();
      } else {
        this.stepper = 1;
        this.switchBillingAddress = false;
      }
    },
  },
  mounted() {},
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    ...mapState("entities", ["editedId"]),
    editedItem: {
      get() {
        return this.$store.state.entities.editedItem;
      },
      set(value) {
        this.$store.commit("entities/setEditedItem", value);
      },
    },
    formTitle() {
      return this.editedId === -1
        ? this.$t("New entity")
        : this.$t("Modify entity");
    },
    countriesList() {
      return Object.keys(this.countries).reduce((acc, x) => {
        acc.push({ code: x, name: this.countries[x] });
        return acc;
      }, []);
    },

    countriesEuropean() {
      return countries.isCountryCodeInEU(this.editedItem.country);
    },

    isFrenchTerritory() {
      return countries.isFrenchTerritory(this.editedItem.billing_country);
    },

    booleanStepper1() {
      let boolStep1 = true;
      if (!this.dataMounted) {
        return boolStep1;
      } else {
        if (
          !(
            this.$refs.form.errors.name == 0 &&
            this.$refs.form.errors.street1 == 0 &&
            this.$refs.form.errors.postal_code == 0 &&
            this.$refs.form.errors.city == 0 &&
            this.$refs.form.errors.country == 0
          )
        ) {
          boolStep1 = false;
        }
      }
      return boolStep1;
    },
    booleanStepper2() {
      let boolStep2 = true;
      if (!this.dataMounted) {
        return boolStep2;
      } else {
        if (
          !(
            this.$refs.form.errors.billing_street1 == 0 &&
            this.$refs.form.errors.billing_postal_code == 0 &&
            this.$refs.form.errors.billing_city == 0 &&
            this.$refs.form.errors.billing_country == 0
          )
        ) {
          boolStep2 = false;
        }
      }
      return boolStep2;
    },
    booleanStepper3() {
      let boolStep3 = true;
      if (!this.dataMounted) {
        return boolStep3;
      } else {
        if (!this.countriesEuropean) {
          if (this.$refs.form.errors.fiscal_number_reference != 0) {
            boolStep3 = false;
          }
        } else if (this.isFrenchTerritory) {
          if (
            !(
              this.$refs.form.errors.siret == 0 &&
              this.$refs.form.errors.vat == 0
            )
          ) {
            boolStep3 = false;
          }
        } else {
          if (!(this.$refs.form.errors.vat == 0)) {
            boolStep3 = false;
          }
        }
      }
      return boolStep3;
    },
  },
  methods: {
    save() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.loading = true;
        if (this.editedId === -1) {
          this.$store
            .dispatch("entities/saveEditedItem")
            .then(() => {
              this.$refs.form.reset();
              this.loading = false;
              this.dialog = false;
              this.snackbar(
                "success",
                this.$t("snackbar-message-entity.added")
              );
            })
            .catch(this.responseError);
        } else {
          this.$store
            .dispatch("entities/updateEditedItem")
            .then(() => {
              this.$refs.form.reset();
              this.loading = false;
              this.dialog = false;
              this.snackbar(
                "success",
                this.$t("snackbar-message-entity.updated")
              );
            })
            .catch(this.responseError);
        }
      });
    },
    responseError(error) {
      this.loading = false;
      if (error.response && error.response.status === 422) {
        let errors = error.response.data.errors;
        this.$refs.form.setErrors(errors);
      } else {
        this.snackbar("error", this.$t("snackbar-message-entity.error"));
      }
    },
    autoCompleteBillingAddress() {
      if (this.switchBillingAddress) {
        this.editedItem.billing_street1 = this.editedItem.street1;
        this.editedItem.billing_street2 = this.editedItem.street2;
        this.editedItem.billing_street3 = this.editedItem.street3;
        this.editedItem.billing_postal_code = this.editedItem.postal_code;
        this.editedItem.billing_city = this.editedItem.city;
        this.editedItem.billing_country = this.editedItem.country;
      } else if (this.editedId === -1) {
        this.editedItem.billing_street1 = null;
        this.editedItem.billing_street2 = null;
        this.editedItem.billing_street3 = null;
        this.editedItem.billing_postal_code = null;
        this.editedItem.billing_city = null;
        this.editedItem.billing_country = null;
      }
    },
  },
};
</script>